import type { ReactElement } from "react"

import { useRecoilValue } from "recoil"
import { RecoilInspector } from "recoil-state-inspector"

import { debugPanelIsPresentState } from "~/containers/LegacyDesigner/Studio/Debug/state"

export default function Inspector(): ReactElement | null {
  const showDebug = useRecoilValue(debugPanelIsPresentState)

  return showDebug ? (
    <RecoilInspector defaultSettings={{ theme: `Github Light` }} />
  ) : null
}
